export interface Alert {
  text: string
  timeout: number
  color: string
  icon?: string
}
export const alertQueue = ref<Alert[]>([])
